export default __webpack_public_path__ + "static/media/off.9ef61043.svg";